<template>
    <div>
        <div class="max-w-500 mx-auto left-0 right-0 bg-mission" :style="{ '--bg-mission-url': 'url(' + imgUrl() + ')' }"></div>
        <div class="max-w-500 mx-auto relative z-10" data-cy="container_mission_detail">
            <TopBarBack data-cy="btn_mission_detail_back" @onClickBack="clickBack()"></TopBarBack>
            <div class="px-4 pt-4 pb-8">
                <div class="bg-a-white-ffffff rounded-lg bg-detail" data-cy="container_mission_detail_content">
                    <div class="text-a-blue-2140a6 text-18 font-bold text-center py-4" data-cy="text_mission_detail_title">
                        {{lbl.mission.detail}}
                    </div>
                    <div class="px-4 pb-4 text-a-gray-666666 text-14" data-cy="text_mission_detail_body">
                        <div  v-html="textDetail"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- <div>
        <div class="max-w-500 mx-auto bg-mission-detail">
            <TopBarBack @onClickBack="clickBack()"></TopBarBack>
            <div class="bg-mission px-4 pt-4 pb-8">
                <div class="bg-a-white-ffffff rounded-lg bg-detail">
                    <div class="text-a-blue-2140a6 text-18 font-bold text-center py-4">
                        {{lbl.mission.detail}}
                    </div>
                    <div class="px-4 pb-4 text-a-gray-666666 text-14">
                        <div  v-html="textDetail"></div>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
</template>
<script>
//helper
// import Util from '@/helper/Utility.js';
import ConfigManager from '@/config/ConfigManager.js';
//component
import TopBarBack from '@/components/Layout/TopBar/TopBarBack.vue';
//mixin
import ModalMixin from '@/mixin/ModalMixin.js';
import AuthPageMixin from '@/mixin/AuthPageMixin.js';
import AuthStatusMixin from '@/mixin/AuthStatusMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin.js';
//service
import MissionService from '../service/MissionService.js';

export default {
    name: "DetailMission",
    mixins: [ModalMixin, AuthPageMixin, AuthStatusMixin, LocaleMixin],
    components: {
        TopBarBack,
    },
    data: function() {
        return {
            textDetail: null
        };
    },
    created: function() {
        this.getMissionDetail();
    },
    methods: {
        getMissionDetail: function() {
            return new Promise((resolve) => {
                MissionService.apiGetMissionDetail(this.localeCode)
                    .subscribe({
                        next: (res) => {
                            this.textDetail = res;
                            resolve(true);
                        },
                        error: (err) => {
                            this.sendError(err);
                            resolve(null);
                        }
                    });
            });
        },
        imgUrl: function() {
            var appId = ConfigManager.getAppId();
            return ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/bg/bg-mission.jpg`;
        },
        clickBack: function() {
            this.$router.back();
        },
    }
}
</script>
 <style lang="scss" scoped>
 @import "@/style/base/base.scss";
 //.bg-mission-detail {
    //background-color: rgb(255, 253, 228);
    //height: 100vh;

    .bg-mission {
        width: 100%;
        height: 100%;
        background-image: var(--bg-mission-url);
        background-repeat: no-repeat;
        background-size: cover;
        background-position: top center;
        position: fixed;

        @media(max-height: 680px){
            height: 100%;
            background-attachment: fixed;
        } 
    }
    .bg-detail {
        // height: auto;
        // max-height: 645px;
        height: calc(100vh - 108px);
        overflow: auto;
    }
//}
</style>
